module.exports = __webpack_public_path__ + "assets/img/bebd00d6aed21a06061a9254871b03a6.png";